export default "__VITE_ASSET__DUjHiLXH__"